import { useState, useEffect } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Reads the current user's client ID from the Cognito ID token payload
 * (custom:user_id claim). Used by CLIENT-role pages that operate on the
 * logged-in user's own client record.
 */
export const useClientId = () => {
  const [clientId, setClientId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    fetchAuthSession()
      .then((session) => {
        const payload = session.tokens?.idToken?.payload;
        const id = (payload?.['custom:user_id'] as string) ?? null;
        if (mounted) {
          setClientId(id);
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (mounted) {
          setClientId(null);
          setIsLoading(false);
        }
      });
    return () => {
      mounted = false;
    };
  }, []);

  return { clientId, isLoading };
};
